import { imageUploadConfig } from './restapi';

interface BlobInfo {
	id: () => string;
	name: () => string;
	filename: () => string;
	blob: () => Blob;
	base64: () => string;
	blobUri: () => string;
	uri: () => string | undefined;
}

type ProgressFn = (percent: number) => void;

export function tinymceImageUploadHandler(blobInfo: BlobInfo, progress: ProgressFn): Promise<string> {
	const options = imageUploadConfig;

	const simpleFilename = blobInfo.filename().replace(/[^A-Za-z0-9.-]/, '_');
	const h = options.headers;
	h['content-disposition'] = 'attachment;filename="' + simpleFilename + '"';

	return fetch(options.uploadUrl, {
		method: 'POST',
		body: blobInfo.blob(),
		headers: h,
	})
		.then(response => response.json())
		.then(data => data.file);
}
